<template>
	<el-main class="info-wrap">
		<div class="info-box">
			<div>
				<div class="info-head tc">
					<h3>资料馆 - 行业最全的特种设备知识库</h3>
				</div>
				<div class="info-content" v-html="infoText">
				</div>
			</div>
		</div>
	</el-main>
</template>

<script>
export default {
	data() {
		return {
             infoText: `
                <ul><li style="text-align: left; line-height: 2;">特规通深知，在繁杂的标准规范中寻找具体数据往往耗时费力。为此，我们将资料馆中的数据进一步提炼，打造了多个实用的专业数据库，方便用户快速查询所需的数值和知识要点：</li><li style="text-align: left; line-height: 2;">术语库、符号库、图库、表库、公式库：基于资料馆文献内容，特规通构建了行业专用的术语、符号、图片、表格和公式五大数据库。相关数据经过结构化整理，您可以直接按关键词检索术语定义、查看标准中出现的符号含义，浏览图示和表格、公式等。这五大基础数据库让零散分布于各法规标准中的元素集中呈现，一目了然，极大地方便了工程计算、报告撰写等日常工作。</li><li style="text-align: left; line-height: 2;">材料库、法兰库：针对压力容器行业用户，特规通特别设置了材料和法兰数据库。我们整合了多部相关标准，收集了压力容器用材料及法兰的各项规格参数、性能指标等数据。无论是选材比对，还是法兰尺寸查询，都可在这里快速获得权威数据支持。</li><li style="text-align: left; line-height: 2;">问答知识库：汇集国家市场监管总局网站发布的特种设备问答知识。在这里，您可以方便地检索官方对各类特种设备法规政策的解读、疑问答复，相当于拥有一个随时查询的权威“百科”，解答您在执行标准法规过程中遇到的疑惑。</li><li style="text-align: left; line-height: 2;">国家标准信息库：面向有更广泛标准需求的用户，我们收录了全国范围内发布的国家标准、行业标准、团体标准的基本信息，并与国家标准化管理委员会信息平台同步更新数据。即使是特种设备领域以外的标准，您也可以在此查询其名称、编号、状态等题录信息，并通过提供的链接跳转至相关平台进行原文阅读。特规通让您的标准检索不再局限于本行业，实现跨领域的一站式查询。</li><li style="text-align: left; line-height: 2;">特规通的数据库模块会根据用户需求持续扩充。未来，我们计划增加化学介质参数数据库、各地气象与地震数据、失效案例库、产品及配件数据库等更多专业数据，为您的工程设计、风险评估和运营管理提供更全面的数据支撑。通过数据库板块，碎片化的信息变得系统有序，专业人员所需的数据尽在弹指之间。</li></ul>
            `
        };
	}
};
</script>

<style lang="less" scoped>
.info-wrap {
	margin-left: 20px;
	padding: 20px 0 !important;
	font-size: 14px;
	color: #475569;
	line-height: 1.8;
	background-color: #fff;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
	border-radius: 12px;
	 min-height: calc(100vh - 120px);
	h3 {
		margin: 0 0 10px;
		font-weight: 600;
		font-size: 24px;
		color: #334155;
	}
}
.info-item {
	margin-bottom: 20px;
}
.info-head {
	margin-bottom: 25px;
	padding-bottom: 15px;
	border-bottom: 1px dashed #e2e8f0;
	.topbox {
		color: #94a3b8;
		dd {
			margin: 0 30px 0 0;
		}
	}
}
</style>

<style lang="less">
.info-content {
		padding: 0 30px;
	}

	.info-content h2 {
		margin: -4px 0 0 !important;
	}


	.info-content ul {
		li {
			line-height: 30px !important;
		}
	}

	.info-content p {
		margin-top: 6px !important;
		margin-bottom: 6px !important;
		line-height: 24px !important;
	}

	.info-content h3 {
		margin: 16px 0 6px !important;
	}

	.info-content h5 {
		color: #0f172a;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		margin-top: 10px;
	}

	.info-content h6 {
		color: #0f172a;
		font-size: 16px;
		margin: 0;
		padding: 0;
		line-height: 34px;
		position: relative;
	}

	.info-content h6:before {
		content: ' ';
		display: inline-block;
		width: 5px;
		height: 5px;
		background: #155dfc;
		border-radius: 50%;
		margin-right: 10px;
		position: absolute;
		top: 16px;
		left: 18px;
	}

	.info-box {
		padding-bottom: 30px;
	}

	.info-content li::marker {
		color: #1456f0;
	}
</style>